var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 464 464",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9CDC1"
    },
    d: "M272,240c0,4,4,8,8,8h48c4,0,8-4,8-8v-48c0-4-4-8-8-8h-48c-4,0-8,4-8,8V240z M280,360h48c4,0,8-4,8-8 v-48c0-4-4-8-8-8h-48c-4,0-8,4-8,8v48C272,356,276,360,280,360z M272,160c0,4,4,8,8,8h48c4,0,8-4,8-8v-48c0-4-4-8-8-8h-48 c-4,0-8,4-8,8V160z M208,184c-4,0-8,4-8,8v48c0,4,4,8,8,8h48c4,0,8-4,8-8v-48c0-4-4-8-8-8H208z M352,96v272H112V96H352z M136,184 c-4,0-8,4-8,8v48c0,4,4,8,8,8h48c4,0,8-4,8-8v-48c0-4-4-8-8-8H136z M208,168h48c4,0,8-4,8-8v-48c0-4-4-8-8-8h-48c-4,0-8,4-8,8v48 C200,164,204,168,208,168z M136,360h48c4,0,8-4,8-8v-48c0-4-4-8-8-8h-48c-4,0-8,4-8,8v48C128,356,132,360,136,360z M208,296 c-4,0-8,4-8,8v48c0,4,4,8,8,8h48c4,0,8-4,8-8v-48c0-4-4-8-8-8H208z M128,112v48c0,4,4,8,8,8h48c4,0,8-4,8-8v-48c0-4-4-8-8-8h-48 C132,104,128,108,128,112z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 312,
    style: {
      fill: "#7AC943"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 200,
    style: {
      fill: "#7AC943"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 120,
    style: {
      fill: "#7AC943"
    },
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 40,
    style: {
      fill: "#42210B"
    },
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M336,160c0,4-4,8-8,8h-48c-4,0-8-4-8-8v-48c0-4,4-8,8-8h48c4,0,8,4,8,8V160z M288,120v32h32v-32H288 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M336,240c0,4-4,8-8,8h-48c-4,0-8-4-8-8v-48c0-4,4-8,8-8h48c4,0,8,4,8,8V240z M288,232h32v-32h-32 V232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M328,360h-48c-4,0-8-4-8-8v-48c0-4,4-8,8-8h48c4,0,8,4,8,8v48C336,356,332,360,328,360z M288,344h32 v-32h-32V344z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 40,
    style: {
      fill: "#42210B"
    },
    width: 80,
    height: 16
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M272,56V40h-80v16H272z M288,40v16h16V40H288z M132,16h200c11.2,0,20,8.8,20,20v44H112V36 C112,24.8,120.8,16,132,16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 312,
    style: {
      fill: "#E94545"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 200,
    style: {
      fill: "#E94545"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 120,
    style: {
      fill: "#E94545"
    },
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M232,440c-12.8,0-24-10.4-24-24s11.2-24,24-24c13.6,0,24,10.4,24,24S245.6,440,232,440z M224,416 c0,4,4,8,8,8s8-4,8-8s-4-8-8-8S224,412,224,416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M248,152v-32h-32v32H248z M256,168h-48c-4,0-8-4-8-8v-48c0-4,4-8,8-8h48c4,0,8,4,8,8v48 C264,164,260,168,256,168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M216,200v32h32v-32H216z M200,192c0-4,4-8,8-8h48c4,0,8,4,8,8v48c0,4-4,8-8,8h-48c-4,0-8-4-8-8V192z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M216,344h32v-32h-32V344z M200,304c0-4,4-8,8-8h48c4,0,8,4,8,8v48c0,4-4,8-8,8h-48c-4,0-8-4-8-8V304 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9900"
    },
    d: "M232,384H112v44c0,11.2,8.8,20,20,20h100h100c11.2,0,20-8.8,20-20v-44H232z M232,440 c-13.6,0-24-11.2-24-24c0-13.6,10.4-24,24-24s24,10.4,24,24C256,428.8,245.6,440,232,440z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 312,
    style: {
      fill: "#FFC600"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 200,
    style: {
      fill: "#FFC600"
    },
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 120,
    style: {
      fill: "#FFC600"
    },
    width: 32,
    height: 32
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M176,120h-32v32h32V120z M128,160v-48c0-4,4-8,8-8h48c4,0,8,4,8,8v48c0,4-4,8-8,8h-48 C132,168,128,164,128,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M144,200v32h32v-32H144z M128,192c0-4,4-8,8-8h48c4,0,8,4,8,8v48c0,4-4,8-8,8h-48c-4,0-8-4-8-8V192z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M144,312v32h32v-32H144z M128,352v-48c0-4,4-8,8-8h48c4,0,8,4,8,8v48c0,4-4,8-8,8h-48 C132,360,128,356,128,352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#42210B"
    },
    d: "M112,368h240V96H112V368z M132,16c-11.2,0-20,8.8-20,20v44h240V36c0-11.2-8.8-20-20-20H132z  M368,428c0,20-16,36-36,36H132c-20,0-36-16-36-36V36c0-20,16-36,36-36h200c20,0,36,16,36,36V428z M112,428c0,11.2,8.8,20,20,20 h100h100c11.2,0,20-8.8,20-20v-44H232H112V428z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7D00"
    },
    d: "M332,16H132c-11.2,0-20,8.8-20,20v44h8V36.8c0-7.2,5.6-12.8,12.8-12.8h197.6c8,0,13.6,5.6,13.6,12.8 V80h8V36C352,24.8,343.2,16,332,16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7D00"
    },
    d: "M344,384v42.4c0,7.2-5.6,13.6-13.6,13.6H133.6c-7.2,0-13.6-5.6-13.6-13.6V384h-8v44 c0,11.2,8.8,20,20,20h100h100c11.2,0,20-8.8,20-20v-44H344z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF8EF"
    },
    d: "M336,112v48c0,4-4,8-8,8h-48c-4,0-8-4-8-8v-48c0-4,4-8,8-8h-24c4,0,8,4,8,8v48c0,4-4,8-8,8h-48 c-4,0-8-4-8-8v-48c0-4,4-8,8-8h-24c4,0,8,4,8,8v48c0,4-4,8-8,8h-48c-4,0-8-4-8-8v-48c0-4,4-8,8-8h-16v256h16c-4,0-8-4-8-8v-48 c0-4,4-8,8-8h48c4,0,8,4,8,8v48c0,4-4,8-8,8h24c-4,0-8-4-8-8v-48c0-4,4-8,8-8h48c4,0,8,4,8,8v48c0,4-4,8-8,8h24c-4,0-8-4-8-8v-48 c0-4,4-8,8-8h48c4,0,8,4,8,8v48c0,4-4,8-8,8h16V104h-16C332,104,336,108,336,112z M192,240c0,4-4,8-8,8h-48c-4,0-8-4-8-8v-48 c0-4,4-8,8-8h48c4,0,8,4,8,8V240z M264,240c0,4-4,8-8,8h-48c-4,0-8-4-8-8v-48c0-4,4-8,8-8h48c4,0,8,4,8,8V240z M336,240c0,4-4,8-8,8 h-48c-4,0-8-4-8-8v-48c0-4,4-8,8-8h48c4,0,8,4,8,8V240z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphone);
export default __webpack_public_path__ + "static/media/smartphone.13d3079835c57bbfa2ce443cb6d74c37.svg";
export { ForwardRef as ReactComponent };